// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login Modal Styles */
.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: var(--spacing-lg);
}

.login-modal {
  background-color: var(--bg-primary);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  max-width: 90%;
  width: 960px;
  max-height: 90vh;
  overflow: hidden;
  position: relative;
  border: 1px solid var(--border-primary);
  border-radius: unset;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.login-modal-close {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 35px;
  height: 35px;
  background-color: var(--proskins-green);
  border: none;
  border-radius: unset;
  color: var(--bg-primary);
  font-size: var(--font-size-lg);
  font-weight: bold;
  cursor: pointer;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
}

.login-modal-close:hover {
  background-color: var(--proskins-green-light);
  transform: scale(1.05);
}

.login-modal-content {
  display: flex;
  min-height: 500px;
  border: 1px solid #fff;
}

/* Left Side - Golf Image */
.login-modal-left {
  flex: 0 0 50%;
  background-color: var(--bg-secondary);
  position: relative;
  overflow: hidden;
}

.login-modal-bg {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.login-modal-bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* Right Side - Login Form */
.login-modal-right {
  flex: 0 0 50%;
  background-color: var(--bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-2xl);
}

.login-modal-form-container {
  width: 100%;
  max-width: 400px;
}

/* Logo */
.login-modal-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.login-modal-logo-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

/* Login Title */
.login-modal-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--proskins-green);
  text-align: center;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-family: 'Oswald', sans-serif;
}

/* Error Message */
.login-modal-error {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm);
  padding: var(--spacing-md);
  background-color: rgba(255, 68, 68, 0.1);
  border: 1px solid rgba(255, 68, 68, 0.3);
  border-radius: var(--radius-md);
  margin-bottom: var(--spacing-lg);
  font-size: var(--font-size-sm);
  color: var(--error);
}

.login-modal-error span {
  font-size: var(--font-size-lg);
  flex-shrink: 0;
  margin-top: var(--spacing-xs);
}

.login-modal-error div {
  flex: 1 1;
}

.login-modal-error strong {
  display: block;
  margin-bottom: var(--spacing-xs);
  font-weight: 600;
}

.login-modal-error p {
  margin: 0;
  line-height: 1.4;
}

/* Form */
.login-modal-form {
  display: flex;
  flex-direction: column;
  /* gap: var(--spacing-lg); */
}

.login-modal-form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.login-modal-label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text-primary);
  text-align: left;
}

.login-modal-input {
  width: 100%;
  color: var(--text-primary);
  font-family: var(--font-family);
  transition: all var(--transition-fast);
  padding: 12px 15px;
  margin-bottom: 15px;
  border-radius: 5px;
  outline: none;
  font-size: 16px;
  border: 0.1px solid #4B4B4B;
  background: transparent;
}

.login-modal-input:focus {
  outline: none;
  border-color: var(--proskins-green);
  box-shadow: 0 0 0 3px rgba(0, 255, 136, 0.1);
}

.login-modal-input::placeholder {
  color: var(--text-muted);
}

.login-modal-input-error {
  border-color: var(--error);
}

.login-modal-input-error:focus {
  border-color: var(--error);
  box-shadow: 0 0 0 3px rgba(255, 68, 68, 0.1);
}

.login-modal-field-error {
  font-size: var(--font-size-xs);
  color: var(--error);
  margin-top: var(--spacing-xs);
}

/* Password Container */
.login-modal-password-container {
  position: relative;
}

.login-modal-password-toggle {
  position: absolute;
  right: var(--spacing-md);
  top: 40%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  font-size: var(--font-size-lg);
  padding: var(--spacing-xs);
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.login-modal-password-toggle:hover {
  color: var(--proskins-green);
  background-color: rgba(0, 255, 136, 0.1);
}

/* Forgot Password */
.login-modal-forgot {
  text-align: right;
  margin-top: -var(--spacing-sm);
  margin-bottom: 15px;
}

.login-modal-forgot-link {
  color: #aaa;
  text-decoration: none;
  font-size: var(--font-size-sm);
  transition: color var(--transition-fast);
}

.login-modal-forgot-link:hover {
  color: var(--proskins-green);
  text-decoration: underline;
}

/* Submit Button */
.login-modal-submit {
  width: 100%;
  padding: 12px;
  background: var(--proskins-green);
  border: none;
  border-radius: 5px;
  color: var(--bg-primary);
  font-family: var(--font-family);
  font-size: var(--font-size-base);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
}

.login-modal-submit:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: var(--shadow-glow);
}

.login-modal-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-modal-loading {
  width: 16px;
  height: 16px;
  border: 2px solid var(--bg-primary);
  border-radius: 50%;
  border-top-color: transparent;
  animation: login-modal-spin 1s ease-in-out infinite;
}

@keyframes login-modal-spin {
  to { transform: rotate(360deg); }
}

/* Register Link */
.login-modal-register {
  text-align: center;
  margin-top: 20px;
}

.login-modal-register-text {
  color: #aaa;
  font-size: var(--font-size-sm);
  margin-right: var(--spacing-sm);
}

.login-modal-register-link {
  color: #aaa;
  text-decoration: underline;
  font-size: var(--font-size-sm);
  font-weight: 600;
  text-transform: uppercase;
  transition: color var(--transition-fast);
  background: unset;
  border: unset;
}

.login-modal-register-link:hover {
  color: var(--proskins-green);
}

/* Responsive Design */
@media (max-width: 768px) {
  .login-modal-overlay {
    padding: var(--spacing-md);
  }
  
  .login-modal-content {
    flex-direction: column;
    min-height: auto;
  }
  
  .login-modal-left {
    flex: 0 0 200px;
    display: none;
  }
  
  .login-modal-right {
    flex: 1 1;
    padding: var(--spacing-lg);
  }
  
  .login-modal-form-container {
    max-width: none;
  }
  
  .login-modal-title {
    font-size: var(--font-size-2xl);
  }
}

@media (max-width: 480px) {
  .login-modal-overlay {
    padding: var(--spacing-sm);
  }
  
  .login-modal-right {
    padding: var(--spacing-md);
  }
  
  .login-modal-logo {
    justify-content: center;
  }
  
  .login-modal-logo-img {
    /* width: 80px;
    height: 80px; */
  }
  
  .login-modal-title {
    font-size: var(--font-size-xl);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/auth/LoginModal.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,wCAAwC;EACxC,wCAAwC;EACxC,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,8BAA8B;EAC9B,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,SAAO;IACP,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE;mBACe;EACjB;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* Login Modal Styles */\n.login-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: var(--spacing-lg);\n}\n\n.login-modal {\n  background-color: var(--bg-primary);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-lg);\n  max-width: 90%;\n  width: 960px;\n  max-height: 90vh;\n  overflow: hidden;\n  position: relative;\n  border: 1px solid var(--border-primary);\n  border-radius: unset;\n  overflow-y: scroll;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.login-modal-close {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  width: 35px;\n  height: 35px;\n  background-color: var(--proskins-green);\n  border: none;\n  border-radius: unset;\n  color: var(--bg-primary);\n  font-size: var(--font-size-lg);\n  font-weight: bold;\n  cursor: pointer;\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n}\n\n.login-modal-close:hover {\n  background-color: var(--proskins-green-light);\n  transform: scale(1.05);\n}\n\n.login-modal-content {\n  display: flex;\n  min-height: 500px;\n  border: 1px solid #fff;\n}\n\n/* Left Side - Golf Image */\n.login-modal-left {\n  flex: 0 0 50%;\n  background-color: var(--bg-secondary);\n  position: relative;\n  overflow: hidden;\n}\n\n.login-modal-bg {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-modal-bg-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n/* Right Side - Login Form */\n.login-modal-right {\n  flex: 0 0 50%;\n  background-color: var(--bg-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-2xl);\n}\n\n.login-modal-form-container {\n  width: 100%;\n  max-width: 400px;\n}\n\n/* Logo */\n.login-modal-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.login-modal-logo-img {\n  width: 120px;\n  height: 120px;\n  object-fit: contain;\n}\n\n/* Login Title */\n.login-modal-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--proskins-green);\n  text-align: center;\n  margin-bottom: 30px;\n  text-transform: uppercase;\n  font-family: 'Oswald', sans-serif;\n}\n\n/* Error Message */\n.login-modal-error {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-md);\n  background-color: rgba(255, 68, 68, 0.1);\n  border: 1px solid rgba(255, 68, 68, 0.3);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--spacing-lg);\n  font-size: var(--font-size-sm);\n  color: var(--error);\n}\n\n.login-modal-error span {\n  font-size: var(--font-size-lg);\n  flex-shrink: 0;\n  margin-top: var(--spacing-xs);\n}\n\n.login-modal-error div {\n  flex: 1;\n}\n\n.login-modal-error strong {\n  display: block;\n  margin-bottom: var(--spacing-xs);\n  font-weight: 600;\n}\n\n.login-modal-error p {\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* Form */\n.login-modal-form {\n  display: flex;\n  flex-direction: column;\n  /* gap: var(--spacing-lg); */\n}\n\n.login-modal-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.login-modal-label {\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  color: var(--text-primary);\n  text-align: left;\n}\n\n.login-modal-input {\n  width: 100%;\n  color: var(--text-primary);\n  font-family: var(--font-family);\n  transition: all var(--transition-fast);\n  padding: 12px 15px;\n  margin-bottom: 15px;\n  border-radius: 5px;\n  outline: none;\n  font-size: 16px;\n  border: 0.1px solid #4B4B4B;\n  background: transparent;\n}\n\n.login-modal-input:focus {\n  outline: none;\n  border-color: var(--proskins-green);\n  box-shadow: 0 0 0 3px rgba(0, 255, 136, 0.1);\n}\n\n.login-modal-input::placeholder {\n  color: var(--text-muted);\n}\n\n.login-modal-input-error {\n  border-color: var(--error);\n}\n\n.login-modal-input-error:focus {\n  border-color: var(--error);\n  box-shadow: 0 0 0 3px rgba(255, 68, 68, 0.1);\n}\n\n.login-modal-field-error {\n  font-size: var(--font-size-xs);\n  color: var(--error);\n  margin-top: var(--spacing-xs);\n}\n\n/* Password Container */\n.login-modal-password-container {\n  position: relative;\n}\n\n.login-modal-password-toggle {\n  position: absolute;\n  right: var(--spacing-md);\n  top: 40%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  font-size: var(--font-size-lg);\n  padding: var(--spacing-xs);\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-fast);\n}\n\n.login-modal-password-toggle:hover {\n  color: var(--proskins-green);\n  background-color: rgba(0, 255, 136, 0.1);\n}\n\n/* Forgot Password */\n.login-modal-forgot {\n  text-align: right;\n  margin-top: -var(--spacing-sm);\n  margin-bottom: 15px;\n}\n\n.login-modal-forgot-link {\n  color: #aaa;\n  text-decoration: none;\n  font-size: var(--font-size-sm);\n  transition: color var(--transition-fast);\n}\n\n.login-modal-forgot-link:hover {\n  color: var(--proskins-green);\n  text-decoration: underline;\n}\n\n/* Submit Button */\n.login-modal-submit {\n  width: 100%;\n  padding: 12px;\n  background: var(--proskins-green);\n  border: none;\n  border-radius: 5px;\n  color: var(--bg-primary);\n  font-family: var(--font-family);\n  font-size: var(--font-size-base);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n}\n\n.login-modal-submit:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-glow);\n}\n\n.login-modal-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.login-modal-loading {\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--bg-primary);\n  border-radius: 50%;\n  border-top-color: transparent;\n  animation: login-modal-spin 1s ease-in-out infinite;\n}\n\n@keyframes login-modal-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Register Link */\n.login-modal-register {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.login-modal-register-text {\n  color: #aaa;\n  font-size: var(--font-size-sm);\n  margin-right: var(--spacing-sm);\n}\n\n.login-modal-register-link {\n  color: #aaa;\n  text-decoration: underline;\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  text-transform: uppercase;\n  transition: color var(--transition-fast);\n  background: unset;\n  border: unset;\n}\n\n.login-modal-register-link:hover {\n  color: var(--proskins-green);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .login-modal-overlay {\n    padding: var(--spacing-md);\n  }\n  \n  .login-modal-content {\n    flex-direction: column;\n    min-height: auto;\n  }\n  \n  .login-modal-left {\n    flex: 0 0 200px;\n    display: none;\n  }\n  \n  .login-modal-right {\n    flex: 1;\n    padding: var(--spacing-lg);\n  }\n  \n  .login-modal-form-container {\n    max-width: none;\n  }\n  \n  .login-modal-title {\n    font-size: var(--font-size-2xl);\n  }\n}\n\n@media (max-width: 480px) {\n  .login-modal-overlay {\n    padding: var(--spacing-sm);\n  }\n  \n  .login-modal-right {\n    padding: var(--spacing-md);\n  }\n  \n  .login-modal-logo {\n    justify-content: center;\n  }\n  \n  .login-modal-logo-img {\n    /* width: 80px;\n    height: 80px; */\n  }\n  \n  .login-modal-title {\n    font-size: var(--font-size-xl);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
